<ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills">
  <a ngbNavItem="home" ngbNavLink routerLink="home" aria-label="home"><i class="fa fa-home fa-lg"></i></a>
  <a ngbNavItem="About" ngbNavLink routerLink="the-company">The Company</a>
  <a ngbNavItem="Product" ngbNavLink routerLink="product">Product</a>
  <a ngbNavItem="Our Team" ngbNavLink routerLink="our-team">Our Team</a>
  <a ngbNavItem="Gallery" ngbDropdown ngbNavLink routerLink="gallery">Gallery</a>
  <a ngbNavItem="Contact" ngbNavLink routerLink="contact">Contact</a>
</ul>